import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSportConfig } from '../context/SportConfig';
import '../styles/Auth.css';

function JoinLeague() {
  const { code } = useParams();
  const { token, isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const sportConfig = useSportConfig();
  const [error, setError] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL || '/api';

  useEffect(() => {
    if (authLoading) return;

    if (!isAuthenticated) {
      navigate(`/login?redirect=/join/${code}`);
      return;
    }

    const joinLeague = async () => {
      try {
        const res = await fetch(`${API_URL}/leagues/join`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ joinCode: code }),
        });
        const data = await res.json();

        if (data.success) {
          navigate(`/leagues/${data.league._id}`);
        } else if (data.leagueId) {
          // Already a member — send them directly to the league page
          navigate(`/leagues/${data.leagueId}`);
        } else {
          setError(data.message || 'Failed to join league');
        }
      } catch (err) {
        setError('Failed to join league. Please try again.');
      }
    };

    joinLeague();
  }, [authLoading, isAuthenticated, code, token, navigate, API_URL]);

  if (error) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>{sportConfig?.appEmoji || '🎾'} {sportConfig?.appName || 'Fantastic Tennis'}</h1>
          <div className="error-message">{error}</div>
          <p style={{ textAlign: 'center', marginTop: '16px' }}>
            <button className="btn btn-primary" onClick={() => navigate('/leagues')}>
              Go to My Leagues
            </button>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>{sportConfig?.appEmoji || '🎾'} {sportConfig?.appName || 'Fantastic Tennis'}</h1>
        <p className="auth-subtitle" style={{ textAlign: 'center' }}>Joining league...</p>
      </div>
    </div>
  );
}

export default JoinLeague;
